import Vue from 'vue';
import Vuex from 'vuex';
import VuesPersistance from 'vuex-persist';
import errorCode from './errorCode.json';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service:process.env.VUE_APP_SERVICE,
    userInfo: {
      loginId: '',
      centerId: '',
      centerName: '',
      garagePoint:'',
      centerPoint:'',
      role:'',
      categoryName:'',
      subRouteName:'',
    },
    centerInfo: {
      centerId:'',
      centerName : '',
      garagePoint: '',
      centerPoint: '',
      weekday : '',
      weekdayFirstDrive : '',
      weekdayLastDrive : '',
      weekdayFirstResv : '',
      weekdayLastResv : '',
      weekend : '',
      weekendFirstDrive : '',
      weekendLastDrive : '',
      weekendFirstResv : '',
      weekendLastResv : '',
      useList : '',
    },
    alert: {
      open: false,
      timeout: undefined,
      title:'',
      msg: '',
      err: null,
      info: true,
      confirm: false,
      confirmBoth: false,
      persistent: false,
      callBack: () => {},
      callBackCancel: () => {}
    },
    snackbar: {
      show: false,
      multiline: true,
      timeout: 5000,
      color: 'red',
      msg: '문제가 발생하였습니다. 잠시후 다시 시도해주세요.',
      err: null,
      where: null,
    },
    config: {},
    keepalive: {},
    luggageList: [
      {label: '없음', value:'없음'},
      {label: '목발', value:'목발'},
      {label: '휠체어', value:'휠체어'},
      {label: '이불', value:'이불'},
      {label: '캐리어', value:'캐리어'},
      {label: '서류', value:'서류'},
      {label: '기타', value:-1},
    ]
  },

  mutations: {
    alert(state, payload) {

      const {err, where, msg, open} = payload;
      let showErr = err;
      let showMsg = msg;

      if(err) {
        if(err.response) {
          const {status, data} = err.response;

          if(status === errorCode.Unauthenticated) {
            showMsg = "세션이 만료되었습니다.\n다시 로그인 해주세요";
          } else if(status === errorCode.BadRequest) {
            if(data && data.length>0) showMsg = data;
          }
          showErr = err.response;
        }
        console.error('Where[', (where|| ''), ']\nError: ', showErr, (showMsg? (`\nMessage: ${showMsg}`): ''));
      }

      //alert 창이 open = false (열릴때) 일 경우에도 alert를 불러오고, 새롭게 default 값을 불러와 모양, 메시지가 모두 다르기에 이 경우를 처리해줌
      //처음에 열리는 순간에는 false 상태였다가 Payload후 현재 open 상태로 (true) 로 고치면서 open = true로 됨. -> 즉 닫힐때는 open == true로 닫힘
      if(state.alert.open) {
        //alert창이 닫힐때는 showMsg에 아무것도 들어오지 않으면서 (undefined) alert 상태를 유지함
        state.alert.msg = showMsg;
      }
      else {
        state.alert = payload;
        //alert창이 열렸을때 에러가 발생했을 경우를 대비하여 메시지를 띄워야함
        state.alert.msg = showMsg || '문제가 발생하였습니다. 잠시후 다시 시도해주세요.';
      }

      state.alert.open = open;
    },
    userInfo(state, payload) {
      state.userInfo = payload;
    },
    config(state, payload){
      state.config = payload;
    },
    keepalive(state, payload){
      state.keepalive = payload;
    },
    snackbar(state, payload) {
      // state.snackbar.multiline = payload.multiline || state.snackbar.multiline;
      // state.snackbar.timeout = payload.timeout || state.snackbar.timeout;
      // state.snackbar.color = payload.color || state.snackbar.color;
      // state.snackbar.message = payload.message || state.snackbar.message;

      const {err, where, msg, timeout, color} = payload;
      let showErr = err;
      let showMsg = msg;

      if(err) {
        if(err.response) {
          const {status, data} = err.response;
          if(status === errorCode.Unauthenticated || status === errorCode.Forbidden) {
            showMsg = data;
          } else if(status === errorCode.BadRequest) {
            if(data && data.length>0) showMsg = data;
          }
          showErr = err.response;
        }
        console.error('Where[', (where|| ''), ']\nError: ', showErr, (showMsg? (`\nMessage: ${showMsg}`): ''));
      }

      state.snackbar.timeout = timeout|| state.snackbar.timeout;
      state.snackbar.color = color|| 'red';
      state.snackbar.msg = showMsg|| '문제가 발생하였습니다. 잠시후 다시 시도해주세요.';
      state.snackbar.err = err;

      state.snackbar.show = true;
    },
    centerInfo(state, payload) {
      state.centerInfo = payload;
    },
    centerUseList(state, payload) {
      state.centerInfo.useList = payload;
    },
    luggageList(state, payload) {
      state.luggageList = payload;
    }
  },

  actions: {
  },

  getters: {
  },

  modules: {
  },

  plugins: [(new VuesPersistance({
    reducer: (state) => ({config: state.config, userInfo: state.userInfo, centerInfo: state.centerInfo}),
  })).plugin]
});
